@if (inEdit) {
  <div class="grid-x">
    <div class="cell small-8 grid-x">
      <div class="cell small-2">
        <button [menuFor]="menu">
          <svg-icon icon="icon-image"></svg-icon>
        </button>
      </div>
      <div  class="cell small-4">
        <input type="color" [formControl]="form.controls.color" />
      </div>
    </div>
    <div class="cell small-4">
      <button class="button small margin-right" (click)="save()">SAVE</button>
      <button class="button small" (click)="cancel()">CANCEL</button>
    </div>
    <div class="cell small-12">
      <label>
        Title
        <input type="text" [formControl]="form.controls.title" />
      </label>
      <label>
        Identifier
        <input type="text" [formControl]="form.controls.identifier" />
      </label>
    </div>
    <div class="cell small-12 checkbox">
      <input class="no-margin vertical-align-text-bottom show-for-sr" type="checkbox" [attr.id]="layer.identifier" [formControl]="form.controls.isConditional" (click)="toggleEditor()"/>
      <label [attr.for]="layer.identifier">
        <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
        Add Layer Conditionally
      </label>
    </div>
    @if (showConditionalEditor) {
      <rules-editor [(rule)]="layer.rule" [placeholder]="'Expression to determine when the layer should be shown'" (updateRule)="ruleCompiled($event)"></rules-editor>
      @if (!layer.rule) {
        <div class="cell small-12 bold red">
          Condition cannot be used until a rule has been successfully compiled!
        </div>
      }
    }
    <h4 class="cell small-12">Geometry</h4>
    @for (item of geometry; track item; let isLast = $last) {
      <div class="cell small-12">
        <geometry-item [geometry]="item"></geometry-item>
        @if (!isLast) {
          <div class="horizontal-rule"></div>
        }
      </div>
    }
  </div>
} @else {
  <div class="grid-x">
    <h4
      [style.color]="layer.color"
    class="cell small-8">{{layer.title}} ({{layer.identifier}})</h4>
    <div class="cell small-4">
      <button class="button small margin-right" (click)="inEdit = !inEdit">EDIT</button>
      <button class="button small" (click)="delete(layer)">DELETE</button>
    </div>
  </div>
}


<menu #menu>
  <div menu-item [menuFor]="geom">Geometry</div>
  <div menu-item [menuFor]="buffer">Buffer</div>
</menu>
<menu #geom>
  @for (item of geometryTypes; track item) {
    <div menu-item (click)="createGeometry(item)">{{item | titlecase}}</div>
  }
</menu>
<menu #buffer>
  <div menu-item>Point</div>
</menu>
